import { render, staticRenderFns } from "./m-roster-class.vue?vue&type=template&id=3a694080&scoped=true&"
import script from "./m-roster-class.ts?vue&type=script&lang=ts&"
export * from "./m-roster-class.ts?vue&type=script&lang=ts&"
import style0 from "./m-roster-class.scss?vue&type=style&index=0&id=3a694080&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a694080",
  null
  
)

export default component.exports